export function templateRoute(path: string, obj: { [x: string]: any } = {}) {
  Object.keys(obj).forEach((key) => {
    const re = new RegExp(`:${key}`, "i");
    path = path.replace(re, obj[key]);
  });

  return path;
}
